import React from "react";
import HomeHero from "./HomeHero.jsx";
import HowItWorks from "./HowItWorks.jsx";
import WhyUs from "./WhyUs.jsx";
import UseCases from "./UseCases.jsx";
// New generic versions for Azaform
import HomeHeroAza from "./HomeHeroAza.jsx";
import HowItWorksAza from "./HowItWorksAza.jsx";
import WhyUsAza from "./WhyUsAza.jsx";

const { REACT_APP_BRAND } = process.env;
const isAzaform =
  (typeof window !== "undefined" && window.location.hostname.includes("azaform")) ||
  REACT_APP_BRAND == "azaform";

const HomeComponent = () => {
  return (
    <div>
      {isAzaform ? (
        <>
          <HomeHeroAza />
          <HowItWorksAza />
          {/* UseCases remains applicable */}
          <UseCases />
          <WhyUsAza />
        </>
      ) : (
        <>
          <HomeHero />
          <HowItWorks />
          <UseCases />
          <WhyUs />
        </>
      )}
    </div>
  );
};

export default HomeComponent;
